import { t } from "@lingui/macro";
import { Box } from "@mui/material";
import {
  WfIconContentEditRegular,
  WfMenuList,
  WfMenuListItem,
  WfPromptCard,
} from "@WahooFitness/redesignr";
import { useCallback } from "react";
import { Container } from "@mui/system";
import FitnessAssessmentImage from "@/assets/FitnessAssessment.png";

export interface EditProfileDrawerProps {
  onStartQuestionnaire: () => void;
  showManualUpdateButton: boolean;
  questionnaireIcon: React.ReactNode;
  onStartFitnessAssessment?: () => void;
  showFitnessAssessmentButton?: boolean;
  onManualUpdateClick: () => void;
}

const EditProfileDrawer = ({
  onStartQuestionnaire,
  showManualUpdateButton,
  questionnaireIcon,
  onStartFitnessAssessment,
  showFitnessAssessmentButton,
  onManualUpdateClick,
}: EditProfileDrawerProps) => {
  const handleOpenUpdateDrawer = useCallback(() => {
    onManualUpdateClick();
  }, [onManualUpdateClick]);

  return (
    <>
      <Container maxWidth="sm" disableGutters>
        <Box p={2} display="flex" flexDirection="column" gap={2} alignItems="stretch" width="100%">
          <WfPromptCard
            imageComponent={questionnaireIcon}
            title={t`Questionnaire`}
            description={t`Estimate your strength and weaknesses as an athlete.`}
            actionText={t`Start questionnaire`}
            onActionClick={onStartQuestionnaire}
            size="medium"
            variant="outlined"
            chipLabel={t`Estimate`}
            time={t`5 min`}
          />
          {showFitnessAssessmentButton && onStartFitnessAssessment && (
            <WfPromptCard
              imageComponent={<img src={FitnessAssessmentImage} alt="Fitness Assessment" />}
              title={t`Fitness Assessment`}
              description={t`A workout designed to measure your power in different intensity and time to precisely identify all 4 metrics.`}
              actionText={t`View workout`}
              onActionClick={onStartFitnessAssessment}
              size="medium"
              variant="outlined"
              chipLabel={t`Most accurate`}
              time={t`59 min`}
            />
          )}
          {showManualUpdateButton && (
            <WfMenuList variant="outlined" width="100%" disableGutters>
              <WfMenuListItem
                id="update-manually"
                variant="action"
                startIcon={<WfIconContentEditRegular />}
                content={t`Update manually`}
                action={handleOpenUpdateDrawer}
              />
            </WfMenuList>
          )}
        </Box>
      </Container>
    </>
  );
};

export default EditProfileDrawer;
